{
  "possibleTypes": {
    "ActivitiesInterface": [
      "AssessmentActivities",
      "LessonActivities"
    ],
    "SectionComponent": [
      "ActivitiesActivityComponent",
      "ActivitiesAudioComponent",
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesColumnsComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDocumentComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEbookComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesGifComponent",
      "ActivitiesGuidedResearchComponent",
      "ActivitiesImageComponent",
      "ActivitiesImageSphereComponent",
      "ActivitiesInfoBoxComponent",
      "ActivitiesInteractiveComponent",
      "ActivitiesInteractiveEbookComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesLinkComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesRiveAnimationComponent",
      "ActivitiesSlideshowComponent",
      "ActivitiesTableComponent",
      "ActivitiesVideoComponent",
      "ActivitiesVocabularyComponent",
      "ActivitiesWebToolComponent"
    ],
    "ActivitiesComponentInterface": [
      "ActivitiesActivityComponent",
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent",
      "ActivitiesAudioComponent",
      "ActivitiesColumnsComponent",
      "ActivitiesDocumentComponent",
      "ActivitiesEbookComponent",
      "ActivitiesGifComponent",
      "ActivitiesGuidedResearchComponent",
      "ActivitiesImageComponent",
      "ActivitiesImageSphereComponent",
      "ActivitiesInfoBoxComponent",
      "ActivitiesInteractiveComponent",
      "ActivitiesInteractiveEbookComponent",
      "ActivitiesLinkComponent",
      "ActivitiesRiveAnimationComponent",
      "ActivitiesSlideshowComponent",
      "ActivitiesVideoComponent",
      "ActivitiesVocabularyComponent",
      "ActivitiesWebToolComponent",
      "ActivitiesRichtextComponent"
    ],
    "ActivitiesSuggestedAnswerInterface": [
      "ActivitiesActivityComponent",
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent"
    ],
    "ActivitiesAnswer": [
      "DrawAnswer",
      "ImageAnswer",
      "InteractiveResponseAnswer",
      "MultipleChoiceAnswer",
      "RichtextAnswer"
    ],
    "ActivitiesAnswerInterface": [
      "DrawAnswer",
      "ImageAnswer",
      "InteractiveResponseAnswer",
      "MultipleChoiceAnswer",
      "RichtextAnswer"
    ],
    "PlainAnswer": [
      "BooleanPlainAnswer",
      "IntPlainAnswer",
      "StringPlainAnswer"
    ],
    "SubActivityComponent": [
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent"
    ],
    "SubActivityComponentInterface": [
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent"
    ],
    "ColumnableComponent": [
      "ActivitiesActivityComponent",
      "ActivitiesAudioComponent",
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDocumentComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEbookComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesGifComponent",
      "ActivitiesGuidedResearchComponent",
      "ActivitiesImageComponent",
      "ActivitiesImageSphereComponent",
      "ActivitiesInfoBoxComponent",
      "ActivitiesInteractiveComponent",
      "ActivitiesInteractiveEbookComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesLinkComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesRiveAnimationComponent",
      "ActivitiesSlideshowComponent",
      "ActivitiesTableComponent",
      "ActivitiesVideoComponent",
      "ActivitiesVocabularyComponent",
      "ActivitiesWebToolComponent"
    ],
    "StimulusResourceInterface": [
      "StimulusResourceDocument",
      "StimulusResourceAudio",
      "StimulusResourceEBook",
      "StimulusResourceEBookInteractive",
      "StimulusResourceGuidedResearch",
      "StimulusResourceImage",
      "StimulusResourceInteractive",
      "StimulusResourceLink",
      "StimulusResourceVideo",
      "StimulusResourceWebTool"
    ],
    "StimulusResource": [
      "StimulusResourceAudio",
      "StimulusResourceDocument",
      "StimulusResourceEBook",
      "StimulusResourceEBookInteractive",
      "StimulusResourceGuidedResearch",
      "StimulusResourceImage",
      "StimulusResourceInteractive",
      "StimulusResourceLink",
      "StimulusResourceVideo",
      "StimulusResourceWebTool"
    ],
    "UserContentReleaseNotificationDetail": [
      "Unit"
    ],
    "AnnotationDetail": [
      "Assessment",
      "Lesson",
      "Unit"
    ],
    "StudentResponse": [
      "ActivityStudentResult",
      "StudentActivityResult"
    ],
    "ActivityContent": [
      "AssessmentActivities",
      "LessonActivities"
    ],
    "AssignedContentData": [
      "AssignedAssessmentData",
      "AssignedLessonData"
    ],
    "AssignmentLinkedContent": [
      "Assessment",
      "Lesson"
    ],
    "ContentDetails": [
      "Assessment",
      "Lesson"
    ],
    "InvalidStudentEntry": [
      "InvalidEmail",
      "InvalidStudentName"
    ],
    "ResponseComponent": [
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent"
    ]
  }
}